import React from 'react';
import { DropdownField } from 'components/common/input';

const FeatureSection = ({ title, features = [], setFeatures, options, handleFeatureChange, addFeature, removeFeature, errors, name }) => {
    return (
        <section className="m-0 p-0">
            <h5 className="m-0 text-title mb-3">{title}</h5>
            <div className="row">
                {features?.map((feature, index) => (
                    <React.Fragment key={index}>
                        <div className="col-md-3">
                            <DropdownField
                                label={title}
                                value={feature[name]}
                                options={options}
                                onChange={(e) => handleFeatureChange(index, name, e.value, setFeatures)}
                                placeholder={`Seleccione la ${title.toLowerCase()}`}
                                error={errors[index]?.[name]}
                            />
                        </div>
                        <div className="col-md-1">
                            <div className="d-flex justify-content-end align-items-center h-100">
                                <i className={feature.icon} style={{ fontSize: '24px', marginRight: '10px' }} />
                                <button
                                    type="button"
                                    onClick={() => removeFeature(index, setFeatures, feature.id)}
                                    className="delete-table delete-button me-2"
                                >
                                    <i className="fa fa-trash" />
                                </button>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
            <button className="btn btn-primary-400 ms-3 mb-3" type="button" onClick={() => addFeature(setFeatures)}>
                <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                Añadir Valor
            </button>
        </section>
    );
};

export default FeatureSection;
